import request from '@/utils/request'

export default {
    getClients: async({ dispatch, commit }, scope) => {
        if (scope === 'selected') {
            commit('SET_NORMALIZE_PHONES', null)
            commit('SET_CLIENTS', [])
            commit('SET_COUNT', 0)
        } else {
            await request({ method: 'get', url: '/notifications/clients/' + scope, timeout: 50000 }) // TODO
                .then(res => {
                    if (res.data) {
                        commit('SET_COUNT', res.data.count)
                        commit('SET_CLIENTS', res.data.clientPhones)
                    }
                })
        }
    },
    createArticle: async({ commit, state }) => {
        const requestData = {
            sendTo: state.filters.sendTo,
            status: state.article.shown ? 'shown' : 'hide',
            header: state.article.title,
            text: state.article.body,
            clientPhones: state.filters.sendTo === 'selected' ? state.filters.phones.split('\n').filter(i => !!i) : undefined
        }

        await request({
            method: 'post', url: '/client-news/create', data: requestData, timeout: 50000
        }).then(res => {
            if (res.data && res.data.android && res.data.ios) {
                commit('SET_RESULT', res.data)
                commit('CLEAR_ARTICLE', null)
            }
        })
    },
    validatePhones: async({ dispatch, commit }, phones) => {
        if (phones.length) {
            commit('SET_LOAD', true)
        }
        await request({
            method: 'post', url: '/notifications/client/validate-phones', params: { skipTokenCheck: true }, data: { phones }, timeout: 50000
        }).then(res => {
            if (res.data) {
                commit('SET_NORMALIZE_PHONES', res.data)

                if (res.data.success && res.data.success.length) {
                    commit('SET_PHONES', res.data.success.map('phone').join('\n'))
                    commit('SET_COUNT', res.data.success.length)
                } else {
                    commit('SET_PHONES', '')
                    commit('SET_COUNT', 0)
                }
                commit('SET_LOAD', false)
            }
        })
    }
}
